import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import PurchaseModal from "../../core/modals/purchases/PurchaseModal";
import { fetchPurchases } from "../../core/redux/slices/purchaseSlice";

const fmt = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

const PurchaseList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.purchases);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => { dispatch(fetchPurchases()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter(
      (p) => !q || p.supplierName?.toLowerCase().includes(q) || p.invoiceNumber?.toLowerCase().includes(q)
    );
  }, [list, search]);

  const columns = [
    { title: "Date", dataIndex: "purchaseDate", width: 110, render: (v) => v ? new Date(v).toLocaleDateString("en-IN") : "—", sorter: (a, b) => (a.purchaseDate || "").localeCompare(b.purchaseDate || "") },
    { title: "Invoice / Bill No.", dataIndex: "invoiceNumber", width: 150 },
    { title: "Supplier", dataIndex: "supplierName" },
    { title: "Payment Mode", dataIndex: "paymentMode", width: 120 },
    {
      title: "Total Amount", dataIndex: "totalAmount", align: "right", width: 140,
      render: fmt,
      sorter: (a, b) => (a.totalAmount || 0) - (b.totalAmount || 0),
    },
    {
      title: "Status", dataIndex: "status", width: 100,
      render: (v) => {
        const map = { Paid: "success", Pending: "warning", Partial: "info" };
        return <span className={`badge bg-${map[v] || "secondary"}`}>{v || "Pending"}</span>;
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Purchases" subtitle="Manage supplier purchase entries" onAdd={() => setShowModal(true)} addLabel="New Purchase" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top d-flex gap-2 flex-wrap align-items-center mb-2">
              <div className="search-input flex-grow-1">
                <input type="text" placeholder="Search supplier or invoice..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => dispatch(fetchPurchases())}>
                Refresh
              </button>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <PurchaseModal show={showModal} onClose={() => { setShowModal(false); dispatch(fetchPurchases()); }} />
    </div>
  );
};

export default PurchaseList;
